// src/components/VerifyEmail.js

import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import api from '../utils/api';
import { toast } from 'react-toastify';

const VerifyEmail = () => {
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const query = new URLSearchParams(useLocation().search);
  const token = query.get('token');
  const navigate = useNavigate();

  useEffect(() => {
    const verifyEmail = async () => {
      if (!token) {
        setMessage('Invalid or missing verification token');
        setIsLoading(false);
        return;
      }

      try {
        const response = await api.post(`/users/verify-email?token=${token}`);
        setMessage('Email verified successfully! You can now log in.');
        toast.success('Email verified successfully!');
        setIsLoading(false);
        
        // Redirect to login after a short delay
        setTimeout(() => {
          navigate('/login');
        }, 3000);
      } catch (error) {
        const errorMessage = error.response?.data?.message || 'Email verification failed';
        setMessage(errorMessage);
        toast.error(errorMessage);
        setIsLoading(false);
      }
    };

    verifyEmail();
  }, [token, navigate]);

  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center', 
      justifyContent: 'center', 
      minHeight: '100vh',
      padding: '20px',
      textAlign: 'center'
    }}>
      <h2>{isLoading ? 'Verifying email...' : message}</h2>
      {isLoading && <div>Please wait...</div>}
    </div>
  );
};

export default VerifyEmail;
